// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"a19063a9","453":"9cc982d1"}[chunkId] + ".chunk.js";
};